import React, { useEffect, useState } from "react";
import { collection, addDoc, updateDoc, doc, serverTimestamp } from "firebase/firestore";
// import { db } from "./firebaseConfig";
import db from '../../firebase/firebase'
import { useLocation, useNavigate } from "react-router-dom";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { FormGroup } from 'reactstrap';

export default function AddDrugRef() {

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const editModel = location.state?.model || null;
    const isEditMode = !!editModel;

    const [title, setTitle] = useState(editModel?.title || "");
    const [description, setDescription] = useState(editModel?.description || "");

    useEffect(() => {
        if (isEditMode) {
            const contentBlock = htmlToDraft(editModel.body);
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            setEditorState(EditorState.createWithContent(contentState))
        }
    }, [])

    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const onEditorStateChange = (editorState) => {
        console.log(JSON.stringify(editorState));
        setEditorState(editorState)
    }

    const saveChanges = async () => {
        let body = draftToHtml(convertToRaw(editorState.getCurrentContent()))

        if (!title || body.length < 10) {
            alert("Title and description are required");
            return;
        }

        setLoading(true);

        const payload = {
            title,
            body,
            updatedAt: serverTimestamp()
        }

        try {
            if (isEditMode) {
                // ✏️ EDIT
                await updateDoc(doc(db, "drug-ref", editModel.id), payload);
                // alert("✅ Case updated successfully");
            } else {
                // ➕ ADD
                await addDoc(collection(db, "drug-ref"), {
                    ...payload,
                    createdAt: serverTimestamp()
                });
                // alert("✅ Case added successfully");
            }
            navigate("/admin/drug-refs");
        } catch (err) {
            console.error(err);
            alert("❌ Failed to save drug references");
        }

        setLoading(false);
    };


    return (
        <div style={styles.container}>
            <h2>{isEditMode ? "Edit Drug Reference" : "Add Drug Reference"}</h2>

            {/* Title */}
            <input
                style={styles.input}
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            />

            {/* Description */}
            <FormGroup style={{ marginTop: 10, width: '100%' }}>
                <div>Description</div>
                <Editor
                    editorStyle={{ backgroundColor: '#fafafa', paddingLeft: 10, paddingRight: 10, height: 200 }}
                    editorState={editorState}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    onEditorStateChange={onEditorStateChange}
                />
            </FormGroup>

            <button
                style={{ marginTop: 0, fontSize: 16, backgroundColor: 'green', color: 'white', borderWidth: 0, padding: 5, borderRadius: 5, width: 300, height: 40 }}
                onClick={saveChanges} disabled={loading}>
                {loading ? "Saving..." : "Save"}
            </button>

        </div>
    );
}

const styles = {
    container: {
        maxWidth: 700,
        margin: "40px auto",
        padding: 20,
        border: "1px solid #ddd",
        borderRadius: 8,
        fontFamily: "sans-serif",
    },
    input: {
        width: "100%",
        padding: 10,
        marginBottom: 10,
    },
    textarea: {
        width: "100%",
        padding: 10,
        marginBottom: 10,
        minHeight: 80,
    },
    row: {
        display: "flex",
        gap: 8,
        alignItems: "center",
    },
};
